// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13300(30670c948c)-C04/11/2026-17:03:44-B04/11/2026-17:46:18' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13300(30670c948c)-C04/11/2026-17:03:44-B04/11/2026-17:46:18",
  branch: "test",
  latestTag: "8.1",
  revCount: "13300",
  shortHash: "30670c948c",
  longHash: "30670c948c8c8bd36ca217ba6b6f2a48b4fca027",
  dateCommit: "04/11/2026-17:03:44",
  dateBuild: "04/11/2026-17:46:18",
  buildType: "Ansible",
  } ;
